export default __webpack_public_path__ + "static/media/personal-trainers-01.d98b4f77.svg";